import { render, staticRenderFns } from "./ModalAlertConfigDelete.vue?vue&type=template&id=603d65cb&lang=pug"
import script from "./ModalAlertConfigDelete.vue?vue&type=script&lang=js"
export * from "./ModalAlertConfigDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports